export const baseUrl = `${process.env.GATSBY_SPLASH_URL}/${process.env.GATSBY_COMPUNY_ID}/analytics/record`;
export const contentUrl = `${process.env.GATSBY_SPLASH_URL}/${process.env.GATSBY_COMPUNY_ID}/data`;